import { Header } from "./components/Header/Header";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { ThemeProvider } from "styled-components";
import { darkTheme, lightTheme } from "./theme";
import "./assets/fonts/Inter/stylesheet.css";
import "./assets/fonts/Poppins/stylesheet.css";
import GlobalCSS from "./Global.styled";
import { MainPage } from "./pages/MainPage";
import { Footer } from "./components/Footer/Footer";
import { Marketplace } from "./pages/Marketplace";
import { NftPage } from "./pages/NftPage";
import { CollectionPage } from "./pages/CollectionPage";
import { UserPage } from "./pages/UserPage";
import { CreateNftPage } from "./pages/CreateNftPage";
import { CreateCollection } from "./components/CreateCollection/CreateCollection";
import { EditProfile } from "./components/Profile/EditProfile/EditProfile";
import { ConnectWallet } from "./components/ConnectModal/ConnectWallet";
import { FaqPage } from "./pages/FaqPage";
import { DisclaimerPage } from "./pages/DisclaimerPage";
import { TermsOfServicePage } from "./pages/TermsOfServicePage";
import { PrivacyPolicy } from "./pages/PrivacyPolicyPage";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  const theme = useSelector((state) => state.app.theme);
  const showCreateCollectionModal = useSelector((state) => state.app.showCreateCollectionModal);
  const showEditProfileModal = useSelector((state) => state.app.showEditProfileModal);
  const showConnectWalletModal = useSelector((state) => state.app.showConnectWalletModal);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <ThemeProvider theme={theme === "light" ? lightTheme : darkTheme}>
        <BrowserRouter>
          <ScrollToTop />
          <GlobalCSS />
          <Header theme={theme} />
          <Routes>
            <Route path='/' element={<MainPage />} />
            <Route path='/marketplace' element={<Navigate to='/marketplace/nfts' replace />} />
            <Route path='/marketplace/nfts' element={<Marketplace active='NFTs' />} />
            <Route path='/marketplace/collections' element={<Marketplace active='Collections' />} />
            <Route path='/marketplace/creators' element={<Marketplace active='Creators' />} />
            <Route path='/marketplace/nfts/:id' element={<NftPage />} />
            <Route path='/marketplace/collections/:id' element={<CollectionPage />} />
            <Route path='/marketplace/creators/:id' element={<UserPage />} />
            <Route path='/create-nft' element={<CreateNftPage />} />
            <Route path='/faq' element={<FaqPage />} />
            <Route path='/disclaimer' element={<DisclaimerPage />} />
            <Route path='/terms-of-service' element={<TermsOfServicePage />} />
            <Route path='/privacy-policy' element={<PrivacyPolicy />} />
          </Routes>
          {showCreateCollectionModal && <CreateCollection />}
          {showEditProfileModal && <EditProfile />}
          {showConnectWalletModal && <ConnectWallet />}
          <Footer />
        </BrowserRouter>
      </ThemeProvider>
    </>
  );
}

export default App;
